import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import posthog from 'posthog-js';

import { useRequestGateway } from '@app-velocity/request-gateway';
import { MessageBus } from '@app-velocity/message-bus';

const messageBus = new MessageBus('users');

export const useLogout = () => {
  const { clearTokens } = useRequestGateway();

  const queryClient = useQueryClient();

  const logout = useCallback(() => {
    clearTokens();
    localStorage.clear();
    queryClient.removeQueries({
      queryKey: ['users', 'figma', 'login-status'],
    });

    queryClient.clear();

    posthog.reset();

    messageBus.publish('logout');
  }, [clearTokens, queryClient]);

  return logout;
};
